/* eslint-disable camelcase */
import React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
export var payedByMonthReferenceColumns = [{
  name: 'Платена главница',
  render: function render(_ref) {
    var principal = _ref.principal,
        currency = _ref.currency;
    return ___EmotionJSX("span", {
      "data-value": "principal"
    }, principal, " ", currency);
  }
}, {
  name: 'Платена лихва',
  render: function render(_ref2) {
    var interest = _ref2.interest,
        currency = _ref2.currency;
    return ___EmotionJSX("span", {
      "data-value": "interest"
    }, interest, " ", currency);
  }
}, {
  name: 'Платена наказателна лихва',
  render: function render(_ref3) {
    var late_fee = _ref3.late_fee,
        currency = _ref3.currency;
    return ___EmotionJSX("span", {
      "data-value": "late_fee"
    }, late_fee, " ", currency);
  }
}, {
  name: 'Месец',
  value: 'month_name'
}];